import React from 'react';
import PrivacyModal from '../components/PrivacyModal';

export default function Privacy() {
  const returnToPublicSite = () => window.location.assign('https://blopboru.com/');
  return (
    <main className="min-h-screen bg-[#0d0916]">
      <PrivacyModal open onClose={returnToPublicSite} />
    </main>
  );
}
